import store from '../store';

import { createDiscussion } from '../actions/discussions';

import { trackEvent } from '../services/events-tracker-service';

export const startConversation = userId => {
    if (!userId) {
        return;
    }

    return createDiscussion({
        invitees: [userId]
    }).then(({ id: conversationId }) => {
        trackEvent('CHAT.CREATE_PERSONAL');

        store.dispatch({
            type: 'TEAMCHAT_ACTIVATE_CONVERSATION_REQUESTED',
            payload: { conversationId }
        });

        return conversationId;
    });
}
